import React, { useEffect, useState } from "react";
import { SiteHeader } from "@/components/SiteHeader";
import { ClinicSettingsPanel } from "@/components/ClinicSettingsPanel";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CreditCard, CheckCircle2, Loader2 } from "lucide-react";

const STATUS_STYLES = {
  active: "bg-green-100 text-green-700",
  trial: "bg-blue-100 text-blue-700",
  past_due: "bg-amber-100 text-amber-700",
  canceled: "bg-slate-200 text-slate-600",
};

function BillingCard() {
  const [cfg, setCfg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    api.get("/billing/config").then((r) => setCfg(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const subscribe = async () => {
    setRedirecting(true);
    try {
      const res = await api.post("/payments/checkout", { origin_url: window.location.origin });
      window.location.href = res.data.checkout_url;
    } catch (e) {
      toast.error("Could not start checkout.");
      setRedirecting(false);
    }
  };

  if (loading) return <div className="rounded-xl border border-slate-200 bg-white p-6"><Loader2 className="h-5 w-5 animate-spin text-slate-400" /></div>;
  const active = cfg?.subscription_status === "active";

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-6" data-testid="billing-card">
      <div className="flex items-center gap-2"><CreditCard className="h-4 w-4 text-slate-400" /><h2 className="font-semibold text-slate-900">Subscription</h2></div>
      <div className="mt-3 flex flex-wrap items-center gap-3">
        <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${STATUS_STYLES[cfg?.subscription_status] || "bg-slate-100 text-slate-600"}`} data-testid="billing-status">
          {cfg?.subscription_status}
        </span>
        <span className="text-sm text-slate-500">Plan: {cfg?.price_display} <span className="text-slate-300">·</span> {cfg?.mode === "test" ? "sandbox" : "live"} mode</span>
      </div>
      <p className="mt-3 text-sm text-slate-500">
        {active
          ? "Your portal is active. Thank you for subscribing."
          : "Subscribe to keep your patient portal active. Use test card 4242 4242 4242 4242 in sandbox mode."}
      </p>
      <Button className="mt-4 bg-[#0F52BA] hover:bg-[#0B3D8A]" onClick={subscribe} disabled={redirecting} data-testid="subscribe-btn">
        {redirecting ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : active ? <CheckCircle2 className="mr-1.5 h-4 w-4" /> : <CreditCard className="mr-1.5 h-4 w-4" />}
        {active ? "Manage / renew subscription" : "Subscribe — $99/month"}
      </Button>
    </div>
  );
}

export default function AdminSettings() {
  return (
    <div className="min-h-screen bg-slate-50">
      <SiteHeader />
      <div className="mx-auto max-w-3xl px-4 py-8 sm:px-6">
        <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">Nimbus Settings</h1>
        <p className="mt-1 text-sm text-slate-500">Branding, paperwork form and subscription.</p>
        <div className="mt-6 space-y-6">
          <BillingCard />
          <ClinicSettingsPanel />
        </div>
      </div>
    </div>
  );
}
